// extracted by mini-css-extract-plugin
export var footer_link__layout = "index-module--footer_link__layout--a45e0";
export var item = "index-module--item--8f0a6";
export var language_selector_wrapper = "index-module--language_selector_wrapper--86523";
export var link_content = "index-module--link_content--dd1ec";
export var list_header = "index-module--list_header--e1d10";
export var list_header__left = "index-module--list_header__left--26616";
export var social_media__list = "index-module--social_media__list--c99c5";
export var social_media_logo = "index-module--social_media_logo--02a0f";
export var title = "index-module--title--6ccd9";